import TimeUtils from '@business/utils/time';
import type { PromoCodeValue } from '@view/components/PromoCode';
import { action, makeObservable, observable } from 'mobx';

function parseUrlParams(url: string): Dict {
  const queryString = url.split('?')[1];
  const hashString = url.split('#')[1];

  const queryParams = new URLSearchParams(queryString);
  const hashParams = new URLSearchParams(hashString);

  const params: Dict = {};

  queryParams.forEach((value, key) => {
    params[key] = value;
  });

  hashParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
}

const getDefaultPromoCodeValue = (): PromoCodeValue => {
  const urlParams =
    typeof window !== 'undefined' ? parseUrlParams(window.location.href) : {};
  const res = {
    checkin: urlParams.checkin
      ? new Date(`${urlParams.checkin}T00:00:00`)
      : TimeUtils.getDateOffset(0),
    checkout: urlParams.checkout
      ? new Date(`${urlParams.checkout}T00:00:00`)
      : TimeUtils.getDateOffset(1),
  };
  return res;
};

export default class PromoCode {
  @observable value: PromoCodeValue = getDefaultPromoCodeValue();

  constructor() {
    makeObservable(this);
  }

  @action.bound set(value: PromoCodeValue) {
    this.value = value;
  }
}
